import { useContext, useEffect, useState, useRef } from "react";
import useIndex from "./useIndex";
import generalIndex from "@beeldit/core/services/index";
import AddQueryParamsToURL from "@beeldit/core/helpers/AddQueryParamsToURL";
import useFilters from "@beeldit/core/helpers/useFilters";
import BeelditTableFilters from "@beeldit/core/components/BeelditTableFilters";
import { ListActionContext } from "@beeldit/core/actions/list/ListActionContext";
import RoomCalendar from "@main/bookings/components/RoomCalendar";

function useListAction(
  modelConfig: any,
  user: any,
  filters: any = {},
  initializeFunction: any,
  getFunction: any
): any {
  const addQueryParamsToURL: any = AddQueryParamsToURL();

  /** Crud functions */
  const index = useIndex(modelConfig);
  const indexFunction = () => index();
  const indexRef = useRef(index);
  indexRef.current = index;

  /** Filter loading */
  const { filtersLoaded } = useContext(ListActionContext);
  const { tableFilters, setTableFilters } = useContext(ListActionContext);
  const { tableConfig, setTableConfig } = useContext(ListActionContext);

  useFilters({ ...{}, ...filters }, ListActionContext);

  /** Index table funcion definition */
  const { tableData } = useContext(ListActionContext);

  // Controlar cuándo ejecutar index() para evitar recargas innecesarias
  const lastFiltersRef = useRef<string>("");

  useEffect(() => {
    if (filtersLoaded) {
      const currentFilters = JSON.stringify(tableFilters);

      // Solo llamar a index() si los filtros realmente han cambiado
      if (lastFiltersRef.current !== currentFilters) {
        lastFiltersRef.current = currentFilters;
        indexRef.current();
      }
    }
  }, [tableFilters, filtersLoaded]);

  /**<newActionsFunctions>**/

  /** Table Filters configuration */
  const filterUIConfig = modelConfig.filterUIConfig;
  const filterConfig = {
    schema: modelConfig.filterConfig,
    uiSchema: filterUIConfig.uiScheme,
    widgets: filterUIConfig.widgets,
    element: tableFilters,
    onChange: (form: any) => {
      setTableFilters(form.formData);
      addQueryParamsToURL(form.formData);
    },
  };

  const [rooms, setRooms] = useState([]);

  useEffect(() => {
    generalIndex("rooms", "")
      .then((response: any) => {
        setRooms(response.data.elements);
      })
      .catch((error: any) => {
        console.log("error getting rooms");
      });
  }, []);

  const roomsCalendaProps = {
    rooms: rooms,
    elements: tableData.elements,
    start_date: tableFilters.from,
    end_date: tableFilters.to,
    initializeFunction: initializeFunction,
    getFunction: getFunction,
  };

  let actionTemplate =
    filtersLoaded && tableConfig ? (
      <>
        <BeelditTableFilters formConfig={filterConfig} />
        <RoomCalendar {...roomsCalendaProps} />
      </>
    ) : (
      <>
        Filters: {filtersLoaded.toString()} table config: {!tableConfig}
      </>
    );
  /** END EDIT TABLE ACTION */

  return {
    indexFunction,
    actionTemplate,
    setTableConfig,
  };
}

export default useListAction;
